import { createContext, useContext, useState, useEffect } from 'react'
import { authAPI } from '../services/api'

const AuthContext = createContext(null)

export const useAuth = () => {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    // Check if user is logged in on mount
    const token = localStorage.getItem('adminToken')
    const savedUser = localStorage.getItem('adminUser')
    
    if (token && savedUser) {
      try {
        setUser(JSON.parse(savedUser))
      } catch (e) {
        localStorage.removeItem('adminToken')
        localStorage.removeItem('adminUser')
      }
    }
    
    setLoading(false)
  }, [])

  const login = async (username, password) => {
    try {
      const response = await authAPI.login(username, password)
      const { token, username: userName } = response.data
      
      const userData = { username: userName, token }
      localStorage.setItem('adminToken', token)
      localStorage.setItem('adminUser', JSON.stringify(userData))
      setUser(userData)
      
      return { success: true }
    } catch (error) {
      const message = error.response?.data?.msg || 'Login failed. Please try again.'
      return { success: false, error: message }
    }
  }

  const logout = async () => {
    try {
      await authAPI.logout()
    } catch (error) {
      // Ignore errors on logout
    } finally {
      localStorage.removeItem('adminToken')
      localStorage.removeItem('adminUser')
      setUser(null)
    }
  }

  const updateUsername = (newUsername) => {
    if (user) {
      const updatedUser = { ...user, username: newUsername }
      setUser(updatedUser)
      localStorage.setItem('adminUser', JSON.stringify(updatedUser))
    }
  }

  const value = {
    user,
    loading,
    login,
    logout,
    updateUsername,
    isAuthenticated: !!user,
  }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

export default AuthContext
